<template>
  <dl>
    <dt>
      <span>{{ itemName }}</span>
      <slot name="aside" />
    </dt>
    <dd>
      <slot />
    </dd>
  </dl>
</template>

<script>
export default {
  name: 'FormLabel',
  props: {
    /** 項目名 */
    itemName: String,
  },
}
</script>

<style lang="postcss" scoped>
dl {
  display: grid;
  grid-gap: 8px;
}

dt {
  align-items: center;
  display: grid;
  font-size: 13px;
  font-weight: bold;
  grid-gap: 8px;
  grid-template-columns: auto 1fr;
  line-height: 1;
}

dd {
  label,
  input {
    width: 100%;
  }
}
</style>
